import { LinkButton, PrimaryButton } from '@oshcut/components'
import { CustomerUser } from '@oshcut/oshlib'
import { useBlockingApi } from 'hooks/useBlockingApi'
import md5 from 'md5'
import { FormEvent, useState } from 'react'
import { DispatchFunction } from 'reducer'
import { StateType } from 'types'
import './SignUpForm.scss'

type SignUpFormProps = {
  state: StateType
  dispatch: DispatchFunction
  onRegister: (result: CustomerUser) => void
}

const SignUpForm = ({ state, dispatch, onRegister }: SignUpFormProps) => {

  const [first, setFirst] = useState('')
  const [last, setLast] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [marketing_opt_in, setMarketingOptIn] = useState(false)
  const [updates_opt_in, setUpdatesOptIn] = useState(false)

  const [apiContent, executeApi, cancelApi] = useBlockingApi()

  const [error, setError] = useState<string>()

  async function handleRegister(e: FormEvent) {
    e.preventDefault()
    if (!first || !last) {
      return setError('Please enter first and last name.')
    }

    if (!email || !password) {
      return setError('Please enter email and password.')
    }

    if (!(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email)))
    {
        return setError('The email address you provided is not valid.')
    }

    let obj = {
      email,
      password: md5(password),
      first,
      last,
      marketing_opt_in,
      updates_opt_in,
    }

    executeApi('/api/v2/customer/create', obj, 
    {
      reason: 'Registering...',
      timeout: 20000,
      timeoutMessage: 'Timed-out while attempting to register',
      resultCallback: (result: any) => {
        if (result.error) {
          setError(result.error)
        }
        else {
          onRegister(result)

          let _window = window as any
          if (_window) {
            if (_window.dataLayer) {
              const convObj = {'event':'registration-submitted','conversionValue':1.0,'email': email, 'firstName': first, 'lastName': last}
              _window.dataLayer.push(convObj);
            }
            if (_window.fbq) {
              _window.fbq('track', 'CompleteRegistration', {
                value: 1.0,
                currency: 'USD',
            });
            }
          }
        }
      }
    })
  }

  function moveToSignIn() {
    dispatch({ type: 'ACTION_CLOSE_SIGNUP_DIALOG' })
    dispatch({ type: 'ACTION_OPEN_SIGNIN_DIALOG' })
  }

  return (
    <form className='SignUpForm' onSubmit={handleRegister}>

      <div className="inputGroup">
        <div className="label"><span>First Name</span></div>
        <input
          name='first'
          value={first}
          onChange={(e) => setFirst(e.target.value)}
          autoComplete="given-name"
        />
      </div>

      <div className="inputGroup">
        <div className="label"><span>Last Name</span></div>
        <input
          name='last'
          value={last}
          onChange={(e) => setLast(e.target.value)}
          autoComplete="family-name"
        />
      </div>

      <div className="inputGroup">
        <div className="label"><span>Email</span></div>
        <input
          name='email'
          type='email'
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="email"
        />
      </div>

      <div className="inputGroup">
        <div className="label">
          <span>Password</span>
        </div>
        <input
          name='password'
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
        />
      </div>

      <div className="checkbox">
        <label>
          <input type="checkbox" checked={updates_opt_in} onChange={_ => setUpdatesOptIn(cv => !cv)} />
          <span>Receive emails about new services, and app updates</span>
        </label>
      </div>

      <div className="checkbox">
        <label>
          <input type="checkbox" checked={marketing_opt_in} onChange={_ => setMarketingOptIn(cv => !cv)} />
          <span>Subscribe to marketing emails</span>
        </label>
      </div>

      {error ? <div className="error">
        {error}
      </div> : null}

      <div className="submit">
        <PrimaryButton type="submit">Create Account</PrimaryButton>
      </div>

      <div className="signIn">
        <span>Already have an account?</span>&nbsp;
        <span className='link' onClick={moveToSignIn}>Sign In</span>
      </div>

      {apiContent}
    </form>
  )
}

export default SignUpForm